import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type ActualsSetFilter = 'all-sets' | 'sets-for-collection' | 'last-sets';

export const SetSelect = ({
  filter,
  disabled,
  setFilter,
  showLabel = true,
}: {
  filter: ActualsSetFilter;
  disabled?: boolean;
  setFilter: (filter: ActualsSetFilter) => void;
  showLabel?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <TextField
      label={showLabel ? t('sets') : undefined}
      select
      disabled={disabled}
      value={filter}
      onChange={(e) => setFilter(e.target.value as ActualsSetFilter)}
      inputProps={!showLabel ? { 'aria-label': t('selectSet') } : undefined}
    >
      <MenuItem key="all-sets" value="all-sets">
        {t('allSets')}
      </MenuItem>
      <MenuItem key="sets-for-collection" value="sets-for-collection">
        {t('markedForCollection')}
      </MenuItem>
      <MenuItem key="last-sets" value="last-sets">
        {t('lastSetOnly')}
      </MenuItem>
    </TextField>
  );
};
